export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const TERMINATE_REGISTRATION = 'TERMINATE_REGISTRATION';

export const UPLOAD_USER_FILE = 'UPLOAD_USER_FILE';
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';

export const SEND_DATA = 'SEND_DATA';
